import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import { actions } from 'state/auth';
import LoginRecoverForm from 'components/auth/LoginRecoverForm/styled';

const enhance = compose(
  withTranslation('Login'),
  connect(() => ({}), {
    login: actions.login,
  })
);

export default enhance(LoginRecoverForm);
